/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useStyles } from "../styles";

interface InnerBottomProps {
  children: React.ReactNode;
}

const InnerBottom = ({ children }: InnerBottomProps) => {
  const { innerBottom } = useStyles();

  return (
    <div css={css(innerBottom)} data-testid="inner-bottom-container">
      {children}
    </div>
  );
};

export { InnerBottom };
